import React from "react";
import type { FC } from 'react';
import logoPath from "./RinggitSymbol.svg"
import './currencyStyles.css'
import { Typography } from "@mui/material";

interface RinggitSymbolProps {
  [key: string]: any;
}

const RinggitSymbol: FC<RinggitSymbolProps> = (props) => {

  return (
    <h1
      // component="div"
      // sx={{
      //   fontSize: {
      //     lg: '2rem',
      //     md: '1.5rem',
      //     sm: '1rem',
      //     xs: '1rem'
      //   },
      //   fontWeight: 'bold'
      // }}
    >
      RM
    </h1>
  );
};

export default RinggitSymbol;